/* eslint-disable @typescript-eslint/no-explicit-any */

import { EAdmissionStages, IAdmissionStages } from '@src/constants/modals/admissions';
import { courseProgramFlatMap } from '@src/helper/admission_helper';
import { create } from 'zustand';

export type AdmissionStage = {
      order: number;
      stage: EAdmissionStages;
      status: number;
};
export type NodeType = {
      id: number;
      name: string;
      type: "level" | "program";
      parent_id: number | null;
      children: NodeType[];
};

export type TCurrentApplicationData =  {
                id: number,
                userId: number,
                applicationNumber: string,
                programId: number,
                programName:string,
                isUserDetailsEditable: boolean,
                applicationStatus: number,
                applicationFeePaid: boolean,
                applicationStatusComments: string | null,
                statusChangedBy: number,
                createdAt: EpochTimeStamp,
                updatedAt: EpochTimeStamp,
                user: {
                    id: number,
                    fullName: string,
                    email: string,
                    phone: string
                }
            }

interface AdmissionStagesState {
      currentStage: number;
      stageStatus: IAdmissionStages[] | null;
      courseProgram: NodeType[] | null;
      courseProgramFlat: Record<number, string> | null;
      rawAdmissionStages:any;
      currentApplicationData:TCurrentApplicationData | null;
      totalWorkExperience: string | null;
      category: string | null;
      setCurrentStage: (stage: number) => void;
      setStageStatus: (status: IAdmissionStages[]) => void;
      setCourseProgram: (program: NodeType[]) => void;
      setCourseProgramFlat: (program: NodeType[]) => void;
      setRawAdmissionStages:(data:any)=> void;
      setCurrentApplicationData:(data:TCurrentApplicationData) => void;
      setTotalWorkExperience: (data: string) => void;
      setCategory: (data: string) => void;
}

export const useAdmissionStagesStore = create<AdmissionStagesState>((set) => ({
      currentStage: 0,
      stageStatus: [],
      courseProgram: null,
      courseProgramFlat: null,
      rawAdmissionStages:null,
      currentApplicationData:null,
      totalWorkExperience:null,
      category:null,
      setCurrentStage: (currentStage) => {
            set({ currentStage: currentStage });
      },
      setStageStatus: (status) => {
            set({ stageStatus: status });
      },
      setCourseProgram: (program) => {
            set({ courseProgram: program });
      },
      setCourseProgramFlat: (program) => {
            set({ courseProgramFlat: courseProgramFlatMap(program) });
      },
      setRawAdmissionStages: (data)=>{
            set({rawAdmissionStages:data});
      },
      setCurrentApplicationData: (data)=>{
            set({currentApplicationData:data})
      },
      setTotalWorkExperience: (data:string) => set({totalWorkExperience:data}),
      setCategory: (data:string) => set({category:data})
}));
